import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const rfidMasterApi = createApi({
  reducerPath: "rfidMasterApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["RfidMaster"],
  endpoints: (builder) => ({
    // CREATE
    addRfidMaster: builder.mutation({
      query: (newRfidMaster) => ({
        url: "/rfid-master/add",
        method: "POST",
        body: newRfidMaster,
      }),
      invalidatesTags: ["RfidMaster"],
    }),

    // LIST
    getAllRfidMasters: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        isActive = "",
        isAssigned = "",
      } = {}) => {
        const params = {
          page,
          limit,
          q: search,
        };

        if (isActive !== "") params.isActive = isActive;
        if (isAssigned !== "") params.isAssigned = isAssigned;

        return {
          url: "/rfid-master",
          params,
        };
      },
      providesTags: ["RfidMaster"],
    }),

    // GET ONE
    getRfidMasterById: builder.query({
      query: (id) => `/rfid-master/${id}`,
      providesTags: (_res, _err, id) => [{ type: "RfidMaster", id }],
    }),

    // UPDATE
    updateRfidMaster: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/rfid-master/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["RfidMaster"],
    }),

    // DELETE
    deleteRfidMaster: builder.mutation({
      query: (id) => ({
        url: `/rfid-master/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RfidMaster"],
    }),

    // BULK EXCEL UPLOAD
    bulkUploadRfidMaster: builder.mutation({
      query: (formData) => ({
        url: "/rfid-master/upload-excel",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["RfidMaster"],
    }),
  }),
});

export const {
  useAddRfidMasterMutation,
  useGetAllRfidMastersQuery,
  useGetRfidMasterByIdQuery,
  useUpdateRfidMasterMutation,
  useDeleteRfidMasterMutation,
  useBulkUploadRfidMasterMutation,
} = rfidMasterApi;

export default rfidMasterApi;